export function showOfficeConfirm(message, options = {}) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");

    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.zIndex = "99999";
    overlay.style.background = "rgba(15, 23, 42, 0.45)";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "20px";

    overlay.innerHTML = `
      <div style="
        width: min(520px, 100%);
        background: #ffffff;
        border-radius: 22px;
        box-shadow: 0 28px 80px rgba(15,23,42,.28);
        border: 1px solid #dbe4f0;
        overflow: hidden;
        font-family: "Segoe UI", Arial, sans-serif;
      ">
        <div style="
          padding: 18px 20px;
          background: linear-gradient(135deg,#eff6ff,#ffffff);
          border-bottom: 1px solid #e2e8f0;
          display:flex;
          gap:12px;
          align-items:center;
        ">
          <div style="
            width:42px;height:42px;border-radius:14px;
            background:#dbeafe;color:#1d4ed8;
            display:flex;align-items:center;justify-content:center;
            font-size:22px;font-weight:650;
          ">⚠️</div>
          <div>
            <div style="font-size:15px;font-weight:700;color:#1f2937;">
              ${options.title || "Office Confirmation"}
            </div>
            <div style="font-size:12px;font-weight:600;color:#64748b;margin-top:3px;">
              Please confirm before posting stock movement.
            </div>
          </div>
        </div>

        <div style="padding:20px;">
          <div style="
            white-space:pre-wrap;
            color:#374151;
            font-size:13px;
            line-height:1.55;
            font-weight:600;
            background:#f8fafc;
            border:1px solid #e2e8f0;
            border-radius:16px;
            padding:14px;
          ">${String(message || "").replaceAll("<", "&lt;").replaceAll(">", "&gt;")}</div>
        </div>

        <div style="
          padding:14px 20px 18px;
          display:flex;
          justify-content:flex-end;
          gap:10px;
          background:#ffffff;
        ">
          <button data-office-cancel style="
            height:40px;
            border:1px solid #cbd5e1;
            background:#ffffff;
            color:#374151;
            border-radius:12px;
            padding:0 16px;
            font-weight:650;
            cursor:pointer;
          ">Cancel</button>

          <button data-office-ok style="
            height:40px;
            border:0;
            background:${options.danger ? "#dc2626" : "#2563eb"};
            color:#ffffff;
            border-radius:12px;
            padding:0 18px;
            font-weight:700;
            cursor:pointer;
            box-shadow:0 10px 25px rgba(37,99,235,.22);
          ">${options.okText || "Confirm"}</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    const cleanup = (value) => {
      overlay.remove();
      resolve(value);
    };

    overlay.querySelector("[data-office-cancel]").onclick = () => cleanup(false);
    overlay.querySelector("[data-office-ok]").onclick = () => cleanup(true);

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) cleanup(false);
    });
  });
}

export function showOfficePrompt(message, defaultValue = "", options = {}) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");

    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.zIndex = "99999";
    overlay.style.background = "rgba(15, 23, 42, 0.45)";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "20px";

    overlay.innerHTML = `
      <div style="
        width: min(560px, 100%);
        background: #ffffff;
        border-radius: 22px;
        box-shadow: 0 28px 80px rgba(15,23,42,.28);
        border: 1px solid #dbe4f0;
        overflow: hidden;
        font-family: "Segoe UI", Arial, sans-serif;
      ">
        <div style="
          padding: 18px 20px;
          background: linear-gradient(135deg,#fff7ed,#ffffff);
          border-bottom: 1px solid #e2e8f0;
          display:flex;
          gap:12px;
          align-items:center;
        ">
          <div style="
            width:42px;height:42px;border-radius:14px;
            background:#ffedd5;color:#c2410c;
            display:flex;align-items:center;justify-content:center;
            font-size:22px;font-weight:650;
          ">📝</div>
          <div>
            <div style="font-size:15px;font-weight:700;color:#1f2937;">
              ${options.title || "Office Note"}
            </div>
            <div style="font-size:12px;font-weight:600;color:#64748b;margin-top:3px;">
              Add note before processing this action.
            </div>
          </div>
        </div>

        <div style="padding:20px;">
          <div style="
            white-space:pre-wrap;
            color:#374151;
            font-size:13px;
            line-height:1.5;
            font-weight:600;
            margin-bottom:10px;
          ">${String(message || "").replaceAll("<", "&lt;").replaceAll(">", "&gt;")}</div>

          <textarea data-office-input style="
            width:100%;
            min-height:110px;
            resize:vertical;
            border:1px solid #cbd5e1;
            border-radius:14px;
            padding:12px;
            font-size:13px;
            font-weight:600;
            outline:none;
            box-sizing:border-box;
          " placeholder="Type office note...">${String(defaultValue || "").replaceAll("<", "&lt;").replaceAll(">", "&gt;")}</textarea>
        </div>

        <div style="
          padding:14px 20px 18px;
          display:flex;
          justify-content:flex-end;
          gap:10px;
          background:#ffffff;
        ">
          <button data-office-cancel style="
            height:40px;
            border:1px solid #cbd5e1;
            background:#ffffff;
            color:#374151;
            border-radius:12px;
            padding:0 16px;
            font-weight:650;
            cursor:pointer;
          ">Cancel</button>

          <button data-office-ok style="
            height:40px;
            border:0;
            background:#2563eb;
            color:#ffffff;
            border-radius:12px;
            padding:0 18px;
            font-weight:700;
            cursor:pointer;
          ">Submit</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    const input = overlay.querySelector("[data-office-input]");
    setTimeout(() => input?.focus(), 50);

    const cleanup = (value) => {
      overlay.remove();
      resolve(value);
    };

    overlay.querySelector("[data-office-cancel]").onclick = () => cleanup(null);
    overlay.querySelector("[data-office-ok]").onclick = () => cleanup(input.value);

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) cleanup(null);
    });
  });
}
